import React, { useContext, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import DSPCharts from './DSP';
import OfficialCharts from './Official';
import RadioCharts from './Radio';

import { EntityContext } from 'context/entityContext';

import { chartsSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import PositionTracker from '../Shared/PositionTracker';

const Charts: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId } = match.params;
  const ctx = useContext(EntityContext);

  const { compareMode, topic } = ctx;

  return (
    <>
      <SubNavigation topic="charts" variants={chartsSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />

      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/charts/dsp`}
        render={(routerProps): ReactNode => (
          <DSPCharts {...ctx} {...routerProps} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/charts/official`}
        render={(routerProps): ReactNode => (
          <OfficialCharts {...ctx} {...routerProps} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/charts/radioCharts`}
        render={(routerProps): ReactNode => (
          <RadioCharts {...ctx} {...routerProps} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/charts/positionTracker`}
        render={(routerProps): ReactNode => (
          <PositionTracker {...ctx} {...routerProps} />
        )}
      />
    </>
  );
};

export default Charts;
